import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const NotificationHeaderSkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        gap: 5,
      }}
    >
      <View style={{ flexDirection: "row", width: "50%", gap: 5 }}>
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 37
              : 40
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "203px"
              : "445px"
          }
          style={{
            marginTop:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 10
                : 20,
          }}
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          width: "50%",
          justifyContent: "flex-end",
        }}
      >
        <Skeletons
          height={30}
          width={"30px"}
          style={{
            marginTop:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 10
                : 20,
          }}
        />
      </View>
    </View>
  );
};

export default NotificationHeaderSkeleton;
